import { createAsyncAction, createAction } from 'redux-promise-middleware-actions';
import { addAsyncActionPostfixes } from '../utils/actionTypeCreator';
import api from '../api/apiSettings';

export const types = {
  CV_OVERSIZE: 'CV_OVERSIZE',
  ...addAsyncActionPostfixes({
    CV_UPLOAD: 'CV_UPLOAD',
    CV_PARSE: 'CV_PARSE',
    CV_UPDATE: 'CV_UPDATE',
    CV_COMPLETE: 'CV_COMPLETE',
    CV_ADD_SKILL: 'CV_ADD_SKILL',
    CV_DELETE_SKILL: 'CV_DELETE_SKILL',
    CV_CHANGE_TOP_SKILL: 'CV_CHANGE_TOP_SKILL',
    RESTORE_AFTER_REFRESH: 'RESTORE_AFTER_REFRESH'
  })
};

export const cvOversize = createAction(types.CV_OVERSIZE, (data) => data);

export const cvUpload = createAsyncAction(types.CV_UPLOAD, (data) =>
  api
    .post('v1/upload-cv', data, {
      headers: {
        'Content-Type': 'multipart/form-data',
        'Access-Control-Allow-Origin': '*'
      }
    })
    .then((res) => res.data)
);

export const cvParse = createAsyncAction(types.CV_PARSE, (data) =>
  api
    .post('v1/parse-cv', data, {
      headers: {
        'Content-Type': 'multipart/form-data',
        'Access-Control-Allow-Origin': '*'
      }
    })
    .then((res) => res.data)
);

export const cvUpdate = (payload) => ({
  type: types.CV_UPDATE,
  payload
});

export const setNewSkill = createAction(types.CV_ADD_SKILL, (skill) => skill);

export const deleteSkillAction = createAction(types.CV_DELETE_SKILL, (skill) => skill);

export const changeTopSkillAction = createAction(types.CV_CHANGE_TOP_SKILL, (skill) => skill);

export const restoreAfterRefresh = createAction(types.RESTORE_AFTER_REFRESH, (data) => data);
